import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import axios from 'axios';

const BannerPruebasPendientes = () => {
  const { API, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [pruebas, setPruebas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || !['estudiante', 'diploma'].includes(user.rol)) {
      setLoading(false);
      return;
    }
    loadPruebas();
  }, [user]);

  const loadPruebas = async () => {
    try {
      const response = await axios.get(`${API}/pruebas-examenes`);
      const todas = response.data || [];
      // Filtrar pruebas activas sin respuesta y que aún no vencieron
      const pendientes = todas.filter(p => 
        p.activa && !p.mi_estado_respuesta && new Date(p.fecha_limite) > new Date()
      );
      setPruebas(pendientes);
    } catch (error) {
      console.error('Error cargando pruebas:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || pruebas.length === 0) return null;

  const tipoTexto = (tipo) => {
    return { quiz: 'Quiz', examen_parcial: 'Examen Parcial', examen_final: 'Examen Final' }[tipo] || 'Evaluación';
  };

  return (
    <div
      onClick={() => navigate('/app/evaluaciones')}
      className="mb-6 bg-gradient-to-r from-amber-50 to-orange-50 border-l-4 border-amber-500 rounded-lg p-4 cursor-pointer hover:shadow-md transition-all group"
      data-testid="banner-pruebas-pendientes"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
            <i className="fas fa-clipboard-check text-amber-600 text-lg"></i>
          </div>
          <div>
            <h3 className="font-bold text-amber-800 text-sm">
              {pruebas.length === 1 
                ? `Tienes 1 ${tipoTexto(pruebas[0].tipo)} pendiente` 
                : `Tienes ${pruebas.length} evaluaciones pendientes`
              }
            </h3>
            <div className="flex flex-wrap gap-2 mt-1">
              {pruebas.slice(0, 3).map(p => (
                <span key={p.id} className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full font-medium">
                  {p.clase_nombre || p.titulo}
                </span>
              ))}
              {pruebas.length > 3 && (
                <span className="text-xs text-amber-600">+{pruebas.length - 3} más</span>
              )}
            </div>
          </div>
        </div>
        <i className="fas fa-chevron-right text-amber-400 group-hover:text-amber-600 group-hover:translate-x-1 transition-all"></i>
      </div>
    </div>
  );
};

export default BannerPruebasPendientes;
